// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.intro-container {
    height: 100vh;
    padding: 0 0 0 100px;
    display: flex;
    justify-content: center;
    flex-direction: column;
    width: 100%;
    margin-top: 0;
}

.intro-name h1, .intro-tags {
    margin: 0;
    font-size: 80px;
    font-weight: 400;
}

.intro-name h1 {
    color: var(--text-color-1);
}

.intro-tags {
    color: var(--text-color-2);
}

.intro-links {
    padding-top: 50px ;
}

.contact-me {
    margin-right: 50px;
    background-color: var(--app-color-3);
    border: none;
    width: 300px;
}

.contact-me:hover {
    background-color: var(--app-color-4);
    color: var(--app-color-2);
}

.resume {
    width: 200px;
}

.resume span {
    margin-right: 5px;
}

.resume:hover {
    background-color: var(--app-color-5);
    color: var(--app-color-2);
}

@media screen and (max-width: 1200px) {
    .intro-name h1, .intro-tags {
        font-size: 50px;
    }   
}

@media screen and (max-width: 900px) {
    .intro-name h1, .intro-tags {
        font-size: 40px;
    }   
}

@media screen and (max-width: 750px) {
    .intro-links a {
        display: block;
    }
    .contact-me {
        margin-right: 0;
        max-width: 100%;
    }

    .resume {
        max-width: 100%;
        margin-top: 20px;
        width: 300px;
    }
}

@media screen and (max-width: 550px) {
    .intro-name h1, .intro-tags {
        font-size: 30px;
    } 
    .intro-container {
        padding-left: 50px;
    }  
    .contact-me {
        background-color: var(--app-color-4);
        color: var(--text-color-1);
    }
}

@media screen and (max-width: 450px) {
    .intro-container {
        padding-left: 30px;
    }
    .intro-name h1, .intro-tags {
        font-size: 30px;
    }  
    .resume, .contact-me {
        width: 160px;
        height: 30px;
    }
}

@media screen and (max-width: 320px) {
    .intro-name h1, .intro-tags {
        font-size: 15px;
    }   
}`, "",{"version":3,"sources":["webpack://./src/Mainbody/intro/intro.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,oBAAoB;IACpB,aAAa;IACb,uBAAuB;IACvB,sBAAsB;IACtB,WAAW;IACX,aAAa;AACjB;;AAEA;IACI,SAAS;IACT,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,oCAAoC;IACpC,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,oCAAoC;IACpC,yBAAyB;AAC7B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,oCAAoC;IACpC,yBAAyB;AAC7B;;AAEA;IACI;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,cAAc;IAClB;IACA;QACI,eAAe;QACf,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,gBAAgB;QAChB,YAAY;IAChB;AACJ;;AAEA;IACI;QACI,eAAe;IACnB;IACA;QACI,kBAAkB;IACtB;IACA;QACI,oCAAoC;QACpC,0BAA0B;IAC9B;AACJ;;AAEA;IACI;QACI,kBAAkB;IACtB;IACA;QACI,eAAe;IACnB;IACA;QACI,YAAY;QACZ,YAAY;IAChB;AACJ;;AAEA;IACI;QACI,eAAe;IACnB;AACJ","sourcesContent":[".intro-container {\n    height: 100vh;\n    padding: 0 0 0 100px;\n    display: flex;\n    justify-content: center;\n    flex-direction: column;\n    width: 100%;\n    margin-top: 0;\n}\n\n.intro-name h1, .intro-tags {\n    margin: 0;\n    font-size: 80px;\n    font-weight: 400;\n}\n\n.intro-name h1 {\n    color: var(--text-color-1);\n}\n\n.intro-tags {\n    color: var(--text-color-2);\n}\n\n.intro-links {\n    padding-top: 50px ;\n}\n\n.contact-me {\n    margin-right: 50px;\n    background-color: var(--app-color-3);\n    border: none;\n    width: 300px;\n}\n\n.contact-me:hover {\n    background-color: var(--app-color-4);\n    color: var(--app-color-2);\n}\n\n.resume {\n    width: 200px;\n}\n\n.resume span {\n    margin-right: 5px;\n}\n\n.resume:hover {\n    background-color: var(--app-color-5);\n    color: var(--app-color-2);\n}\n\n@media screen and (max-width: 1200px) {\n    .intro-name h1, .intro-tags {\n        font-size: 50px;\n    }   \n}\n\n@media screen and (max-width: 900px) {\n    .intro-name h1, .intro-tags {\n        font-size: 40px;\n    }   \n}\n\n@media screen and (max-width: 750px) {\n    .intro-links a {\n        display: block;\n    }\n    .contact-me {\n        margin-right: 0;\n        max-width: 100%;\n    }\n\n    .resume {\n        max-width: 100%;\n        margin-top: 20px;\n        width: 300px;\n    }\n}\n\n@media screen and (max-width: 550px) {\n    .intro-name h1, .intro-tags {\n        font-size: 30px;\n    } \n    .intro-container {\n        padding-left: 50px;\n    }  \n    .contact-me {\n        background-color: var(--app-color-4);\n        color: var(--text-color-1);\n    }\n}\n\n@media screen and (max-width: 450px) {\n    .intro-container {\n        padding-left: 30px;\n    }\n    .intro-name h1, .intro-tags {\n        font-size: 30px;\n    }  \n    .resume, .contact-me {\n        width: 160px;\n        height: 30px;\n    }\n}\n\n@media screen and (max-width: 320px) {\n    .intro-name h1, .intro-tags {\n        font-size: 15px;\n    }   \n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
